import React, { FC } from 'react'
import { Typography } from '@mui/material'
import { Loader, ModuleHeader, ModuleBody } from 'components'

const LoggingOut: FC = () => (
  <>
    <Loader />
    <ModuleHeader title="Logging out">
      <ModuleBody>
        <Typography variant="body1">
          Please wait while we log you out of BrightMLS.com.
        </Typography>
      </ModuleBody>
    </ModuleHeader>
  </>
)

export default LoggingOut
